package com.shadowings.gero.data.lessons.chapter14

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import kotlin.random.Random
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_1
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_10
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_11
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_12
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_13
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_14
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_15
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_2
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_3
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_4
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_5
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_6
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_7
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_8
import gero.composeapp.generated.resources.exp_content_il_verbo_ma_i_9
import gero.composeapp.generated.resources.exp_title_il_verbo_ma_i

fun getIlVerboMaIContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_1,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "U2:D4", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_2,
            face = Faces.Surprised,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "U2:D4", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_3,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "U2:D4", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_4,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "U2:D4-A1", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_5,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_6,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_8,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_9,
            face = Faces.Happy,
            character = Characters.Alyn
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_10,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_13,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_14,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_verbo_ma_i,
            content = Res.string.exp_content_il_verbo_ma_i_15,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}

fun getIlVerboMaIQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    return getLaParticellaNiQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random
    )
}
